<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="bold section">{{ title }}</div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>

    <div class="ui grid">      
      <div class="eleven wide computer sixteen wide tablet sixteen wide mobile column">
        <button class="ui blue button" @click="$router.push('/admin/user-groups/new')">
          <i class="plus icon"></i> Novo Grupo
        </button>
      </div>
      <div class="five wide computer sixteen wide tablet sixteen wide mobile column">
        <div class="ui basic right aligned segment no-padding no-margin">
          <div class="ui form">
            <div class="field">
              <search-input id="user-groups-search-input" ref="searchInput" @onSearch="search" />
            </div>
          </div>    
        </div> 
      </div>
    </div>

    <data-table id="user-groups-dtbl" ref="dtbl" :service="service" :attributes="attributes" :fields="fields" @onRowClick="navToGroupForm" />

  </div>

</template>

<script>
  
  import UserGroupService from "@/services/user-group-service"
  import { gridPage, onlySimavet } from "@/mixins"

  export default {    

    name: "UserGroupsPage",

    mixins: [gridPage, onlySimavet],

    data() {
      return {        
        title: "Grupos de Usuários",
        service: new UserGroupService(),
        attributes: ["id", "name"],
        fields: [          
          { prop: "name", label: "Nome do Grupo" },
        ],
      }
    },

    methods: {

      navToGroupForm(data) {
        this.$router.push("/admin/user-groups/" + data.row.id)
      },
    },
  }

</script>
